import "./Buttons.scss";
import React from "react";

interface ButtonProps {
  href?: string;
  click?: any;
  text: string;
}

const Button: React.FC<ButtonProps> = ({ href, click, text }) => {
  return (
    <>
      {(() => {
        switch (true) {
          case typeof click !== "undefined":
            return (
              <div className="button" onClick={() => click()}>
                <h4>{text}</h4>
              </div>
            );
          case typeof href !== "undefined":
            return (
              <a href={href ? href : "/"}>
                <div className="button">
                  <h4>{text}</h4>
                </div>
              </a>
            );
          default:
            return (
              <div className="button">
                <h4>{text}</h4>
              </div>
            );
        }
      })()}
    </>
  );
};

export default Button;
